module.exports = __webpack_public_path__ + "static/media/third_party_verification_banner.04264a36.jpeg";